import { Box, Button, CircularProgress, Drawer, IconButton, Paper, Stack, SwipeableDrawer, TextField, Typography } from "@mui/material"
import { ReactComponent as CloseIcon } from "../../../pages/Meds/modules/Drawers/assets/Close.svg";
import { IDeviation, IMedCard, INorm, INormTable, IReportStatus, MedCardStatuses, NormCodes } from "../../Meds/types"
import { activeColor, drawerBoxStyle, textFieldOutlineMultilineStyle } from "../../Meds/styles/styles"
import { buttonStyle } from "../../Login/login-styles"
import { MedDataTable } from "../../Meds/components/MedDataTable"
import { getTableDataFromCard } from "../../Meds/MedCardPageModel"
import { getArchiveUrlRequest, getNormsRequest } from "../../../services/DriverCardService"
import { Fragment, useEffect, useState } from "react"
import { MainDataCard } from "../../Meds/components/MainDataCard"
import classes from './report.module.css'
import { DriverIdentInfo } from "../../Meds/components/DriverIdentInfo"
import { $file } from "../../../api"
import { getStatusChip } from "../ReportPageModel"
import { DownloadIcon } from "../assets/DownloadIcon"
import { VideoPlayer } from "../../../modules/Player/VideoPlayer";
import { useAppSelector } from "../../../store/hooks/redux";
import { getVideoBlobSrc } from "../../../services/fileService";



export interface ReportCardProps {
    open: boolean,
    onClose: any,
    onOpen: any,
    card: IMedCard | null,
    cardsApiUrl?: string
}


export const downloadFile = (url: string, filename: string) => {

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}


export const ReportCard = ({ open, onClose, onOpen, card }: ReportCardProps) => {
    const { reportsApi } = useAppSelector(state => state.appReducer)
    const [norms, setNorms] = useState<INorm[] | undefined>()

    //TODO: сменить ссылку с currentApiUrl на отдельную для страницы отчётов.
    const getNorms = async (api_url: string) => {
        try {
            const response = await getNormsRequest(api_url);
            console.log('norms')
            console.log(response)
            setNorms(response.data)
        } catch (e) {

        }
    }

    useEffect(() => {
      if (reportsApi) {
        getNorms(reportsApi.baseUrl.slice(0, -3))
      }
    }, [reportsApi])



    const normTableData: INormTable | null = !!norms && norms !== null ? {
        systolicPressure: norms.find((element: INorm) => {
            return element.code === NormCodes.SYSTOLIC
        }),
        diastolicPressure: norms.find((element: any) => {
            return element.code === NormCodes.DIASTOLIC
        }),
        pulse: norms.find((element: any) => {
            return element.code === NormCodes.PULSE
        }),
        temperature: norms.find((element: any) => {
            return element.code === NormCodes.TEMPERATURE
        }),
        alcohol: norms.find((element: any) => {
            return element.code === NormCodes.ALCOHOL
        }),
    } : null




    const download = async (url?: string) => {
        console.log(url)
        if (!!url) {
            const fileUrl = await $file.get(url);
            const localUrl = URL.createObjectURL(fileUrl.data)
            downloadFile(localUrl, 'documents.zip')
        }
    }

    const [archivesUrl, setArchivesUrl] = useState(null)
    const [loadingProtocol, setLoadingProtocol] = useState(false)
    const [loadingReferral, setLoadingReferral] = useState(false)
    useEffect(() => { setArchivesUrl(null) }, [card])
    const getArchiveUrl = async (name: string) => {
      let archives: any = archivesUrl
      if (archives === null) {
        archives = (await getArchiveUrlRequest(reportsApi.baseUrl.slice(0, -3), Number(card?.id!)))?.data
        setArchivesUrl(archives)
      }
      if (name === 'protocol' && archives?.archive_url) {
        download(archives?.archive_url)
      } else
      if (name === 'referral' && archives?.archive_url2) {
        download(archives?.archive_url2)
      }
    }

    const [videoSrc, setVideoSrc] = useState<any>(null)
    useEffect(() => {
      if (card?.full_url) {
        if (card?.full_url?.slice(-4) !== '.bin') {
          setVideoSrc('loading')
          getVideoBlobSrc(card?.full_url).then((result) => setVideoSrc(result))
        } else {
          setVideoSrc(card?.full_url)
        }
      } else {
        setVideoSrc(null)
      }
    }, [card])

    return (
        <Drawer
            anchor={'right'}
            open={open}
            onClose={onClose}
            sx={{
                //height: 'fit-content',

                '*::-webkit-scrollbar': {
                    width: '24px',
                },
                '*::-webkit-scrollbar-track': {
                    backgroundColor: '#EEEEEE',
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: '#8E8E8E',
                    border: '6px solid transparent',
                    //borderTopWidth: '0px',
                    //borderBottomWidth: '0px',
                    // borderRadius: '10px / 4px',
                    borderRadius: '10px / 10px',
                    backgroundClip: 'content-box',
                },
            }}
        >
            <Box sx={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '24px', backgroundColor: '#EEEEEE'
            }}>
                <Typography sx={{ fontSize: '20px', fontWeight: '500', lineHeight: '23px', color: '#3E3E3E' }} component={'h1'}>Карточка осмотра</Typography>
                <IconButton onClick={onClose} color="secondary" aria-label="add an alarm"
                    sx={{'&.MuiButtonBase-root': {borderRadius: '4px'}, '&:hover': {backgroundColor: '#FFFFFF'}}}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box
                sx={{
                    ...drawerBoxStyle,
                    width: '748px',
                    //width: '100%',

                    overflowX: 'hidden',
                    paddingLeft: '24px',
                }}
                role="presentation"
            >
                <Stack sx={{ gap: '16px' }}>
                    <DriverIdentInfo
                        driver={card?.driver}
                        statusChip={getStatusChip(card?.medical_report?.status as IReportStatus)}
                        coverBgColor={'#D9D9D9'} coverPadding={'12px'} textSize={'16px'} textGap={'12px'} showPhotoTitle={false}
                    />
                    <MedDataTable
                        normsData={normTableData}
                        actualData={getTableDataFromCard(card)}
                        coverBgColor={'#D9D9D9'} coverPadding={'12px'} textSize={'16px'} textGap={'12px'}
                    />
                    {card?.medical_report?.status === IReportStatus.REJECTED || 
                     card?.medical_report?.status === IReportStatus.DEFECTED ||
                     card?.medical_report?.status === IReportStatus.ABORTED
                        ? <Stack
                            sx={{borderRadius: '4px 4px 4px 4px', boxShadow: 'none', backgroundColor: '#D9D9D9', padding: '12px', gap: '12px'}}
                        >
                            <Typography sx={{ fontWeight: '500', fontSize: '16px', lineHeight: '20px', color: '#3E3E3E' }}>Причины недопуска</Typography>
                            <Stack gap={1}>
                                {card?.medical_report?.deviations?.map((element: any) => {
                                    return <Box sx={{ padding: '12px', backgroundColor: activeColor, borderRadius: '4px' }}>
                                        <Typography color={'white'}>
                                            {element.name}
                                        </Typography>
                                    </Box>
                                })}
                                {card?.medical_report?.defects?.map((element: any) => {
                                    return <Box sx={{ padding: '12px', backgroundColor: activeColor, borderRadius: '4px' }}>
                                        <Typography color={'white'}>
                                            {element.name}
                                        </Typography>
                                    </Box>
                                })}
                                {!!card?.medical_report?.comment && <Box>
                                    <Box >
                                        {/* <Typography>
                                            Комментарий
                                        </Typography>
                                        <Typography>
                                            {card?.medical_report?.comment}
                                        </Typography> */}

                                        <TextField
                                            sx={{...textFieldOutlineMultilineStyle, userSelect: 'none'}}
                                            multiline
                                            rows={4}
                                            size="small"
                                            value={card?.medical_report?.comment}
                                            fullWidth
                                            label={'Комментарий медика'}
                                            variant="outlined"

                                            disabled
                                            InputLabelProps={{shrink: false}}
                                            InputProps={{readOnly: true}}
                                        />
                                        
                                    </Box>
                                </Box>}
                            </Stack>

                        </Stack>
                        : <></>
                    }

                    <Stack sx={{ padding: '12px', gap: '24px', borderRadius: '4px', backgroundColor: '#D9D9D9', width: '100%' }}>
                        <Typography sx={{ fontWeight: '500', fontSize: '16px', lineHeight: '20px', color: '#3E3E3E' }}>
                            Видеоматериал
                        </Typography>
                        <VideoPlayer
                            faceProcessingServiceResult={card?.faceProcessingServiceResult}
                            url={videoSrc ?? undefined}
                            autoPlay={true} muted={true} flipping={card?.flipping} style={{borderRadius: '4px', width: '100%', height: '500px'}}
                        />
                    </Stack>

                </Stack>



            </Box>

            <Box
                sx={{
                    backgroundColor: '#EEEEEE',
                    position: 'sticky',
                    bottom: '0px',
                    padding: '24px',

                    display: 'flex',
                    gap: '24px',
                    justifyContent: 'space-around'
                }}
            >
                <Button 
                    disabled={ card?.protocol_and_referral_url === null }
                    sx={{ ...buttonStyle, width: '330px', backgroundColor: activeColor, '&:hover': { backgroundColor: '#007DB8', boxShadow: 'none' } }} 
                    startIcon={/*loadingProtocol ? <CircularProgress sx={{color: '#FFFFFF'}} size={'20px'}/> : */<DownloadIcon/>}
                    onClick={() => { setLoadingProtocol(true); getArchiveUrl('protocol').then(() => setLoadingProtocol(false)) }}
                    variant="contained"
                >
                    Протокол осмотра
                </Button>
                <Button
                    disabled={ card?.referral_url === null || card?.medical_report?.status === IReportStatus.DEFECTED }
                    sx={{ ...buttonStyle, width: '330px', backgroundColor: activeColor, '&:hover': { backgroundColor: '#007DB8', boxShadow: 'none' } }} 
                    startIcon={/*loadingReferral ? <CircularProgress sx={{color: '#FFFFFF'}} size={'20px'}/> : */<DownloadIcon/>}
                    onClick={() => { setLoadingReferral(true); getArchiveUrl('referral').then(() => setLoadingReferral(false)) }}
                    variant="contained"
                >
                    Направление к врачу
                </Button>
            </Box>




            {/* </Box> */}
        </Drawer >
    )
}